import { isResource } from '@medplum/core'
import type { Basic, Practitioner, Reference } from '@medplum/fhirtypes'
import { codeableConcept, hasCodeableConcept } from '#src/codeableConcept.ts'
import {
  BASIC_CODE_SYSTEM,
  TASK_VIEW_FILTERS_SYSTEM,
  TASK_VIEW_GROUPING_SYSTEM,
  VIEW_ACCESS_TAG_SYSTEM,
} from '#src/codeSystems.ts'
import { Extension } from '#src/decorators.ts'
import { View, type ViewAccess } from '#src/models/view.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export type TaskViewGrouping = 'state' | 'participant'

export class TaskView extends View {
  static isInstance(value: unknown): value is Basic {
    return (
      isResource(value) &&
      isOfType(value, 'Basic') &&
      hasCodeableConcept(value.code, codeableConcept(TaskView.code))
    )
  }

  constructor({
    name,
    filters,
    owner,
    grouping,
    access,
  }: {
    name: string
    filters: string
    owner: Reference<Practitioner>
    grouping?: TaskViewGrouping
    access?: ViewAccess
  }) {
    super({
      code: codeableConcept(TaskView.code),
      name,
      owner,
      access,
    })
    this.filters = filters
    this.grouping = grouping
  }

  @Extension({
    url: TASK_VIEW_GROUPING_SYSTEM,
    kind: 'valueString',
  })
  grouping?: TaskViewGrouping

  @Extension({
    url: TASK_VIEW_FILTERS_SYSTEM,
    kind: 'valueString',
  })
  filters: string

  static queryForPractitioner(
    practitioner: Reference<Practitioner>
  ): QueryTypes {
    return {
      code: TaskView.code,
      _tag: View.status.active,
      _filter: `(_tag eq ${VIEW_ACCESS_TAG_SYSTEM}|${practitioner.reference} or _tag eq ${VIEW_ACCESS_TAG_SYSTEM}|shared)`,
      _sort: 'identifier',
      _count: '1000',
    }
  }

  static code = {
    system: BASIC_CODE_SYSTEM,
    code: 'task-view',
    display: 'Task View',
  }
}
